import React from 'react';

export default function XLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M14.6711 14.8545C14.6163 14.9525 14.5357 15.0343 14.4378 15.0913C14.3398 15.1484 14.2281 15.1785 14.1143 15.1787H10.296C10.1889 15.1787 10.0835 15.1521 9.98966 15.1014C9.8958 15.0508 9.81647 14.9777 9.75904 14.8889L6.53817 9.91777L1.85761 14.974C1.74351 15.0944 1.58569 15.1658 1.41838 15.1726C1.25107 15.1795 1.08775 15.1213 0.963824 15.0107C0.839897 14.9001 0.765356 14.746 0.75636 14.5817C0.747364 14.4175 0.804639 14.2564 0.915768 14.1334L5.8294 8.8209L0.849744 1.13965C0.788414 1.04515 0.754082 0.936197 0.750342 0.824196C0.746602 0.712195 0.773592 0.601266 0.828486 0.503025C0.88338 0.404784 0.964159 0.322846 1.06236 0.265789C1.16057 0.208732 1.27259 0.178657 1.38669 0.178711H5.20496C5.31206 0.178744 5.41742 0.205324 5.51128 0.255991C5.60514 0.306657 5.68447 0.379769 5.7419 0.468555L8.96277 5.43965L13.6433 0.383398C13.7574 0.263022 13.9152 0.191667 14.0826 0.184801C14.2499 0.177936 14.4132 0.236115 14.5371 0.346723C14.661 0.457332 14.7356 0.611456 14.7446 0.775681C14.7536 0.939906 14.6963 1.101 14.5852 1.22402L9.67154 6.53262L14.6512 14.2186C14.7122 14.3131 14.7462 14.422 14.7497 14.5339C14.7532 14.6457 14.726 14.7565 14.6711 14.8545Z"
        fill="#919BAB"
      />
    </svg>
  );
}
